module.exports = __webpack_public_path__ + "static/media/Headshot.5dab14a7.jpeg";